export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#FFE376',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#F1370F',
    contrastText: '#FFFFFF',
    light: '#FFFFFF',
  },
  secondary: {
    main: '#076187',
    contrastText: '#FFFFFF',
  },
  text: {
    primary: '#111111',
    light: 'rgba(71, 86, 112, 0.8)',
    secondary: '#5E6C77',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#26364D',
    primary: '#10B7F2',
    paper: '#FFF',
    default: '#FFF',
    header: '#26364D',
    footer: '#B73438',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#000000',
    tableSubhead: '#F7F7F7',
    arrow: '#10B7F2',
    tableAlternate: '#F8F8F8',
    alternate: '#FFFFFF',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#B73438',
    secondary: '#F8D859',
  },
  verticalBar: {
    used: '#4499F7',
    unused: '#FFFFFF',
    unlimited: '#C0C0C0',
  }
};
